export const GET_PROD_LOADING = 'admin/products/loading'
export const GET_PROD_SUCCESS = 'admin/products/success'
export const GET_ALL_PROD_SUCCESS = 'admin/ALL/products/success'
export const GET_PROD_FAIL = 'admin/products/fail'
export const ADD_PROD_LOADING = 'admin/products/add/loading'
export const ADD_PROD_ERROR = 'admin/products/add/error'
export const ADD_PROD_SUCCESS = 'admin/products/add/success'
export const GET_USER_LOADING = 'admin/users/loading'
export const GET_USER_ERROR = 'admin/users/error'
export const GET_USER_SUCCESS = 'admin/users/success'